import React from "react";
import './BannerStart.css';
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";

function BannerStart(props) {
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}
    return (
            <div className="BannerStart">
            <div className="BannerStartRight">
                <div className="BannerStartTitle">
                    <TextSource ArrIndex= 'index0170'>Simple. Transparent</TextSource>
                    <br/>
                    <TextSource ArrIndex= 'index0175'>Trade with Confidence</TextSource>
                </div>
                <div className="BannerStartText">
                    <ul>
                        <li><TextSource ArrIndex= 'index0180'>EASY TO START, NO EXTRA PAPERWORK</TextSource> </li>
                        <li><TextSource ArrIndex= 'index0185'>ONE-CLICK DEPOSITS AND WITHDRAWALS</TextSource> </li>
                        <li><TextSource ArrIndex= 'index0190'>NO HIDDEN CHARGES</TextSource> </li>
                    </ul>
                    <div className="BannerStartButton ButtonOut">
                        <ChangeLink to={'/account/open'} lang={props.lang} style={{textDecoration: 'none'}}>
                            <div className='ButtonYellow'>
                                <TextSource ArrIndex= 'index0195'>START TRADING RIGHT AWAY</TextSource>
                            </div>
                        </ChangeLink>
                    </div>
                </div>

            </div>
            </div>
    )}

export default BannerStart





